/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_In_DeliveryInputs */

const vi_notif_type_in_delivery = /** @type {(inputs: Notif_Type_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giao`)
};

/**

* @param {Notif_Type_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_in_delivery = /** @type {((inputs?: Notif_Type_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_in_delivery(inputs)
});